import React from "react";

const StatusMeticCard = ({ totalActiveLinks }) => {
  return (
    <div className="rounded-xl h-fit w-full duration-300 cursor-pointer dark:bg-accent-800 bg-white border dark:border-none border-primary-50 shadow-sm min-w-[240px] overflow-hidden">
      <div className="md:py-20px py-3 md:px-25px px-16px flex flex-col justify-end h-full relative">
        <div className="md:text-4xl text-3xl text-primary-300 dark:text-primary-200 font-semibold md:my-16px my-10px">
          {totalActiveLinks || 0}
        </div>
        <div className="font-normal text-primary-300 dark:text-primary-400 md:text-base text-sm m-0 ">
          Active links
        </div>
        <Icon />
      </div>
    </div>
  );
};
export default StatusMeticCard;
function Icon() {
  return (
    <span className="absolute right-0 bottom-0 h-fi max-h-[136px]">
      <svg
        className="h-full"
        width="210"
        height="136"
        viewBox="0 0 268 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_306_192)">
          <path
            d="M128.023 159.494L106.235 107.039C98.7 88.898 98.67 70.7793 106.145 52.6826C113.62 34.5859 126.428 21.77 144.569 14.235C162.709 6.69998 180.828 6.67001 198.925 14.1451C217.022 21.6202 229.837 34.428 237.372 52.5687L259.16 105.024L232.933 115.918L211.145 63.4627C206.606 52.5346 198.923 44.8344 188.096 40.3621C177.268 35.8899 166.391 35.9233 155.463 40.4625C144.535 45.0016 136.834 52.6848 132.362 63.5119C127.89 74.339 127.923 85.2166 132.463 96.1447L154.251 148.6L128.023 159.494ZM164.137 98.3644L190.364 87.4704L233.94 192.38L207.713 203.274L164.137 98.3644ZM138.917 185.721L165.145 174.827L186.933 227.282C191.472 238.21 199.155 245.91 209.982 250.383C220.809 254.855 231.687 254.822 242.615 250.282C253.543 245.743 261.243 238.06 265.715 227.233C270.188 216.406 270.154 205.528 265.615 194.6L243.827 142.145L270.054 131.251L291.842 183.706C299.377 201.847 299.407 219.965 291.932 238.062C284.457 256.159 271.649 268.975 253.509 276.51C235.368 284.045 217.249 284.075 199.153 276.6C181.056 269.125 168.24 256.317 160.705 238.176L138.917 185.721Z"
            className="fill-secondary-700"
          />
        </g>
        <path
          opacity="0.8"
          d="M272.63 207L250.634 185.117C244.669 189.074 238.239 192.103 231.342 194.204C224.445 196.306 217.144 197.357 209.44 197.357C199.125 197.357 189.433 195.41 180.361 191.515C171.29 187.621 163.399 182.336 156.688 175.66C149.978 168.984 144.665 161.133 140.751 152.108C136.836 143.083 134.879 133.44 134.879 123.178C134.879 115.513 135.936 108.25 138.048 101.388C140.161 94.527 143.205 88.1291 147.182 82.1948L125 60.1268L135.625 49.5563L283.254 196.43L272.63 207ZM201.984 182.15V167.685C197.883 167.685 194.372 166.233 191.452 163.327C188.532 160.422 187.072 156.93 187.072 152.85V145.432L151.283 109.826C150.91 112.052 150.568 114.277 150.257 116.502C149.947 118.728 149.791 120.953 149.791 123.178C149.791 138.138 154.731 151.243 164.61 162.493C174.489 173.743 186.947 180.296 201.984 182.15ZM271.698 163.791L260.886 153.035C263.496 148.461 265.515 143.67 266.944 138.663C268.373 133.656 269.088 128.495 269.088 123.178C269.088 111.063 265.702 99.9977 258.929 89.9836C252.156 79.9695 243.116 72.7371 231.808 68.2864V71.2535C231.808 75.3333 230.348 78.8259 227.427 81.7312C224.507 84.6365 220.996 86.0892 216.896 86.0892H201.984V94.4343L168.618 61.2394C174.583 57.4069 180.982 54.4088 187.817 52.2453C194.652 50.0818 201.859 49 209.44 49C219.754 49 229.447 50.9472 238.518 54.8415C247.59 58.7359 255.481 64.0211 262.191 70.6972C268.902 77.3732 274.214 85.2238 278.128 94.2488C282.043 103.274 284 112.917 284 123.178C284 130.72 282.913 137.89 280.738 144.69C278.563 151.49 275.55 157.857 271.698 163.791Z"
          className="fill-secondary-600"
        />
        <defs>
          <filter
            id="filter0_f_306_192"
            x="0.561157"
            y="-91.4388"
            width="396.955"
            height="473.622"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="50"
              result="effect1_foregroundBlur_306_192"
            />
          </filter>
        </defs>
      </svg>
    </span>
  );
}
